import { XMarkIcon } from "@heroicons/react/20/solid";
import { isEmpty } from "lodash";
import Tag from "../../../shared/components/Tag";
import * as serviceTypes from "../../../../data/booking/constants/service_types";
import {useTranslation} from "react-i18next";

export default function RouteCard({ hike, isSelected }) {
    let pictureUrl = !isEmpty(hike.pictures)
        ? hike.pictures["vignette"]
        : "/assets/img/banners/sucs.jpg";
    const { t } = useTranslation();

    return (
        <div
            className={`relative flex h-full w-full justify-center shadow-lg transition
        ${
            isSelected
                ? "grid lg:grid-cols-3 lg:grid-rows-1 grid-cols-1 grid-rows-3 rounded-lg shadow-orange-100 ring ring-orange-500 ring-offset-4"
                : "hover:scale-105  hover:shadow-xl"
        }`}
        >
            {isSelected && (
                <div className="absolute top-[-8px] right-[-8px] -z-[9] rounded-full bg-white shadow  ring ring-orange-500">
                    <XMarkIcon className="h-7 w-7 text-gray-700" />
                </div>
            )}
            {isSelected && (
                <>
                    <div className="absolute -top-2 -right-2 z-10 rounded-full bg-white shadow-xl transition hover:scale-105">
                        <XMarkIcon className="h-7 w-7 text-gray-700" />
                    </div>
                </>
            )}

            <div
                className={`
                relative flex w-full flex-col rounded-lg bg-white
                transition-all duration-75 ease-in-out
                hover:cursor-pointer           
             
            `}
            >
                {hike.tags && hike.tags.length > 0 && (
                    <div className="absolute top-0 left-0 z-10 space-x-1 pt-1 pl-2">
                        {hike.tags.map((tag, index) => (
                            <Tag
                                color={tag.color}
                                key={index}
                                label={tag.label ? tag.label : tag.value}
                            />
                        ))}
                    </div>
                )}

                <div
                    className={`${
                        isSelected ? "h-full lg:rounded-l-xl lg:rounded-tr-none rounded-t-xl" : "aspect-w-6 aspect-h-4"
                        // isSelected ? "h-full lg:rounded-l-xl lg:rounded-tr-none rounded-t-xl" : "aspect-w-6 aspect-h-4"
                    } w-full bg-cover`}
                    style={{
                        backgroundImage: `url(${pictureUrl})`,
                    }}
                ></div>

                {!isSelected && (
                    <div className="my-auto px-6 py-2">
                        <h5 className="font-medium text-gray-900">{hike.title}</h5>
                    </div>
                )}
            </div>

            {isSelected && (
                <div className="lg:col-span-2 row-span-2 bg-white px-4">
                    <div className="my-auto px-6 py-4">
                        <h2 className="mb-2 text-center text-base font-bold text-gray-800">
                            {hike.title}
                        </h2>
                        <div
                            className={
                                "mx-auto mt-2 flex justify-center space-x-6 text-center text-xs text-gray-500"
                            }
                        >
                            {hike.course?.distance && <div className={"flex items-center"}>
                                <img
                                    alt="Distance"
                                    className="mr-2 w-7"
                                    src="/assets/img/icons/services/old/g-distance.png"
                                />
                                {hike.course.distance} km
                            </div>}
                            {hike.course?.averageTime &&
                                <div className={"flex items-center"}>
                                <img
                                    alt="Durée"
                                    className="mr-2 w-7"
                                    src="/assets/img/icons/services/old/g-clock.png"
                                />
                                {hike.course.averageTime} jours
                            </div>}
                            {hike.course?.elevation &&
                                <div className={"flex items-center"}>
                                <img
                                    alt="Dénivelé"
                                    className="mr-2 w-7"
                                    src="/assets/img/icons/services/old/g-height-difference.png"
                                />
                                {hike.course.elevation} m
                            </div>}
                        </div>
                        <div className={"mt-8"}>
                            <ul className={"grid gap-y-4 sm:w-[80%] w-1/2 galaxy:w-3/4 lg:w-full lg:mx-0 mx-auto lg:gap-x-0 gap-x-4 sm:grid-cols-2"}>
                                {serviceTypes.getServiceList().filter((service)=> {
                                    return isEmpty(hike.services) || hike.services.includes(service.type)
                                }).map(service=> <li key={service.type} className="flex sm:mx-0 items-center space-x-2 text-xs text-gray-700">
                                    <img
                                        className="w-12"
                                        src={`https://www.lamallepostale.com/assets/img/icons/services/g-${service}.png?48a515454b8de2c4f23c7881ce3c05243fbd3352`}
                                        src={"/assets/img/icons/services/g-" + service.icon + ".png"}
                                    />
                                    <p className="block">
                                        {t(service.title)}
                                    </p>
                                </li>)}
                            </ul>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
